export async function updateForeignBankAccount(foreignBankAccountRepository, bankAccount, bankAccountId) {
  return foreignBankAccountRepository.update(bankAccount, bankAccountId);
};

